/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useReducer, createContext, useEffect } from 'react'
import moment from 'moment'
import { isEmpty } from 'lodash'
import { FilterFactory } from '../types/FilterFactory'
import { defaultFormatTimeZone } from '../utils/consts'

interface FactoryFiltersContextType {
  filters: FilterFactory
  setFilters: (filters: FilterFactory) => any
}
const initialState: FactoryFiltersContextType = {
  filters: {
    factory: [],
    brands: [],
    clients: [],
    newOrderStatus: [],
    orderCreatedAt: {
      initialDate: moment().clone().subtract(15, 'days').format('YYYY-MM-DD'),
      finalDate: moment().clone().format('YYYY-MM-DD'),
      ...defaultFormatTimeZone
    }
  },
  setFilters: () => {}
}
const storageItem = 'filters-brands-portal-analytics'
let localState: object = {}
if (!isEmpty(sessionStorage.getItem(storageItem))) localState = JSON.parse(sessionStorage.getItem(storageItem) || '{}')

const reducer = (state: any, newState: any) => {
  if (newState === null) {
    sessionStorage.removeItem(storageItem)
    return initialState
  }

  return { ...state, filters: { ...state.filters, ...newState } }
}

export const FactoryFiltersContext = createContext(initialState)

const FactoryFiltersContextProvider: React.FC = (props: any) => {
  const [filters, setFilters] = useReducer(reducer, !isEmpty(localState) ? localState : initialState)
  useEffect(() => {
    sessionStorage.setItem(storageItem, JSON.stringify(filters))
  }, [filters])

  return (
    <FactoryFiltersContext.Provider value={{ ...filters, setFilters }}>
      {props.children}
    </FactoryFiltersContext.Provider>)
}

export default FactoryFiltersContextProvider
